module.exports = "/_next/static/media/0a204d7f49a6756f93db98395543cff4.svg";